// Module
var code = "<span class=\"glyphicon glyphicon-info-sign amt-tooltip\" tooltip-placement=\"{{tooltipPlacement}}\" tooltip-html-unsafe=\"{{content}}\" tooltip-append-to-body=\"true\"></span>";
// Exports
module.exports = code;